<nav class="navbar navbar-expand-lg navbar-dark">
    <div class="container-fluid">
        <a class="navbar-brand" href="#">Mon Appli Gateaux</a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li routerLinkActive="router-link-active" class="nav-item">
                    <a routerLinkActive="router-link-active" routerLink="/gateaux" class="nav-link" aria-current="page">Gateaux</a>
                </li>

                <li routerLinkActive="router-link-active" class="nav-item">
                    <a routerLinkActive="router-link-active" routerLink="/panier" class="nav-link">Panier (<strong>{{nombreGateauxDansLePanier()}}</strong>)</a>
                </li>

            </ul>

        </div>
    </div>
</nav>

